import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useWizard, WizardStepLayout } from 'components/layout/wizards';
import { fetchPrebuildWorkers } from 'store/slices/workersSlice';
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';

export default function PrebuildWorkerStep() {
  const dispatch = useDispatch();
  const { nextStep, data } = useWizard();
  const [search, setSearch] = useState('');
  const [workers, setWorkers] = useState([]);
  const [selectedWorker, setSelectedWorker] = useState(data.selectedWorker || null);

  useEffect(() => {
    const fetchWorkers = async () => {
      try {
        const response = await dispatch(fetchPrebuildWorkers()).unwrap();
        setWorkers(response.data);
      } catch (_error) {
        // error handled silently; no loading UI in this step
      }
    };
    fetchWorkers();
  }, [dispatch]);

  const filteredWorkers = workers.filter(w => 
    w.name.toLowerCase().includes(search.toLowerCase()) || 
    w.description.toLowerCase().includes(search.toLowerCase())
  );

  const handleNext = () => {
    if (selectedWorker) {
      nextStep({ selectedWorker });
    }
  };

  return (
    <WizardStepLayout
      title="Select Prebuild Worker"
      description="Choose a worker from the library."
      primaryAction={{
        label: 'Next',
        onClick: handleNext,
        disabled: !selectedWorker
      }}
    >
      <div className="space-y-6">
        <div className="relative">
          <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
            <MagnifyingGlassIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
          </div>
          <input
            type="text"
            className="block w-full rounded-md border-0 bg-gray-700/50 py-1.5 pl-10 pr-3 text-white shadow-sm ring-1 ring-inset ring-gray-600 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-500 sm:text-sm sm:leading-6"
            placeholder="Search workers..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          {filteredWorkers.map((worker) => (
            <div
              key={worker.id}
              className={`relative flex cursor-pointer rounded-lg border p-4 shadow-sm focus:outline-none ${
                selectedWorker?.id === worker.id
                  ? 'border-indigo-600 ring-2 ring-indigo-600 bg-gray-800'
                  : 'border-gray-700 bg-gray-800/50 hover:bg-gray-800'
              }`}
              onClick={() => setSelectedWorker(worker)}
            >
              <div className="flex flex-1">
                <div className="flex flex-col">
                  <span className="block text-sm font-medium text-white">{worker.name}</span>
                  <span className="mt-1 flex items-center text-sm text-gray-400">{worker.description}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </WizardStepLayout>
  );
}
